module.exports = __webpack_public_path__ + "img/msteams.fe65f0d6.svg";